import { Stack } from '@mui/material';

import ShortlistList from '@/karehero-app/care/shortlists/ShortlistList';
import { type PublishedShortlist } from '@/karehero-app/care/shortlists/fixtures';

// The shortlists page content: the Stack under Body holding the list of published
// shortlists.
//
// No page header. It read "Care search" over a line explaining that these are the
// shortlists a care expert made, under a tab that already names the section —
// three namings of the same thing before the family reached the first card.
const CareSearchContent = ({
  shortlists,
  onOpen,
}: {
  shortlists: PublishedShortlist[];
  onOpen: (shortlist: PublishedShortlist) => void;
}) => (
  <Stack spacing={2}>
    <ShortlistList shortlists={shortlists} onOpen={onOpen} />
  </Stack>
);

export default CareSearchContent;
